/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { ResponderPage } from '@/app/(client)/questionnaires/-components/ResponderPage';
import { answerRequestQueryOptions } from '@/app/(client)/questionnaires/-hooks/useAnswerRequestQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/questionnaires/(pages)/(detail)/$id_/answer/',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData(answerRequestQueryOptions(params.id)),
  component: QuestionnaireAnswerRoute,
});

function QuestionnaireAnswerRoute() {
  const { id } = Route.useParams();
  return <ResponderPage requestId={id} />;
}
